<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" @command="handleCommand" v-if="(isBoss || isAdmin) && !isDisabledProject">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_more_task1"></i>
        更多选项
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown filter-more-dropdown">
        <el-dropdown-item
        v-for="(item,index) in dataset"
        :key="index"
        :command="index"
        >
          <span><i :class="`icon iconfont ${item.icon}`"></i>{{item.label}}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import bus from '@/bus'
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      dataset: [{
        label: '批量选择',
        icon: 'iconicon_batch_selection'
      },{
        label: '查看任务回收站',
        icon: 'iconicon_recycle_bin'
      }],
    }
  },
  computed: {
    ...mapState('task/task', {
      isDisabledProject: state => state.isDisabledProject
    })
  },
  methods: {
    ...mapMutations('task/task', ['set_checkStatus']),
    handleCommand(index) {
      switch(index) {
        case 0:
          this.set_checkStatus(true)
          break
        case 1:
          bus.$emit('goToRecycleBin')
          // bus.$emit('editVisible', true)
      }

    }
  }
}
</script>
<style lang="scss">
.filter-status {
}
.filter-more-dropdown {
  width: 157px !important;
}
</style>
